import {billingConstants} from "../_constants/billing.constants";


const INITIAL_STATE = {
    url: '',
    error: '',

    loadingBillingsSummary: true,
    billingsSummary: [],
    billingSummaryError: '',

    loadingOrganizationBillings: true,
    organizationBillings: [],
    organizationBillingsError: ''
};

export function billingReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case billingConstants.GET_BILLING_SETTINGS_REQUEST:
            return { ...state };
        case billingConstants.GET_BILLING_SETTINGS_SUCCESS:
            return { ...state, url: action.url };
        case billingConstants.GET_BILLING_SETTINGS_FAILURE:
            return { ...state, error: action.error };

        case billingConstants.GET_BILLING_SUMMARY_REQUEST:
            return { ...state, loadingBillingsSummary: true };
        case billingConstants.GET_BILLING_SUMMARY_SUCCESS:
            return { ...state, billingsSummary: action.payload, loadingBillingsSummary: false };
        case billingConstants.GET_BILLING_SUMMARY_FAILURE:
            return { ...state, billingSummaryError: action.error, loadingBillingsSummary: false };


        case billingConstants.GET_ORGANIZATION_BILLINGS_REQUEST:
            return { ...state, loadingOrganizationBillings: true };
        case billingConstants.GET_ORGANIZATION_BILLINGS_SUCCESS:
            return { ...state, organizationBillings: action.payload, loadingOrganizationBillings: false };
        case billingConstants.GET_ORGANIZATION_BILLINGS_FAILURE:
            return { ...state, organizationBillingsError: action.error, loadingOrganizationBillings: false };

        default:
            return state
    }
}
